module.exports = __webpack_public_path__ + "images/emoji/earth_asia.34d97b77400cc5eec781.png";